<template>
  <b-modal
    v-model="show"
    :title="isEdit ? 'Editar Integração' : 'Nova Integração'"
    size="lg"
    no-close-on-backdrop
    @hidden="onHidden"
  >
    <b-overlay :show="isSaving" rounded="sm">
      <b-row>
        <b-col md="8">
          <b-form-group label="Nome da integração *">
            <b-form-input v-model="form.nome" placeholder="Ex: Sincronizar Clientes ERP" />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Status">
            <b-form-select v-model="form.status">
              <b-form-select-option value="ATIVA">Ativa</b-form-select-option>
              <b-form-select-option value="INATIVA">Inativa</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="9">
          <b-form-group label="URL *">
            <b-form-input v-model="form.url" placeholder="https://erp.exemplo.com/api/v1/clientes" />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="Método">
            <b-form-select v-model="form.metodo">
              <b-form-select-option value="GET">GET</b-form-select-option>
              <b-form-select-option value="POST">POST</b-form-select-option>
              <b-form-select-option value="PUT">PUT</b-form-select-option>
              <b-form-select-option value="PATCH">PATCH</b-form-select-option>
              <b-form-select-option value="DELETE">DELETE</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Usuário">
            <b-form-input v-model="form.usuario" placeholder="Opcional (Basic Auth)" autocomplete="off" />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group :label="isEdit ? 'Senha (deixe em branco para manter)' : 'Senha'">
            <b-form-input v-model="form.senha" type="password" placeholder="Opcional" autocomplete="new-password" />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Headers (JSON)">
            <b-form-textarea
              v-model="form.headersStr"
              rows="3"
              placeholder='{ "X-API-Key": "abc123" }'
              :state="headersValido"
            />
            <small v-if="headersValido === false" class="text-danger">JSON inválido — corrija para salvar.</small>
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group label="Body">
            <b-form-textarea v-model="form.body" rows="4" placeholder='{ "campo": "valor" }' />
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="Timeout (ms)">
            <b-form-input v-model.number="form.timeout_ms" type="number" min="1000" max="120000" />
          </b-form-group>
        </b-col>
      </b-row>
    </b-overlay>

    <template #modal-footer>
      <b-button variant="outline-secondary" @click="show = false">Cancelar</b-button>
      <b-button variant="primary" :disabled="isSaving || headersValido === false" @click="salvar">
        <b-spinner v-if="isSaving" small class="mr-50" />
        {{ isEdit ? 'Salvar' : 'Cadastrar' }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

const EMPTY = () => ({
  integracaoid: null,
  nome: '',
  url: '',
  usuario: '',
  senha: '',
  metodo: 'GET',
  headersStr: '',
  body: '',
  status: 'ATIVA',
  timeout_ms: 30000,
});

export default {
  name: 'IntegracaoModal',
  data() {
    return {
      show: false,
      form: EMPTY(),
    };
  },
  computed: {
    ...mapGetters('IntegracaoErp', ['isSaving']),
    isEdit() { return !!this.form.integracaoid; },
    headersValido() {
      const s = (this.form.headersStr || '').trim();
      if (!s) return null;
      try { const p = JSON.parse(s); return p && typeof p === 'object' && !Array.isArray(p); } catch (e) { return false; }
    },
  },
  methods: {
    ...mapActions('IntegracaoErp', ['criar', 'atualizar']),
    open(item) {
      if (item) {
        this.form = {
          integracaoid: item.integracaoid,
          nome: item.nome || '',
          url: item.url || '',
          usuario: item.usuario || '',
          senha: '',
          metodo: item.metodo || 'GET',
          headersStr: item.headers
            ? (typeof item.headers === 'string' ? item.headers : JSON.stringify(item.headers, null, 2))
            : '',
          body: item.body || '',
          status: item.status || 'ATIVA',
          timeout_ms: item.timeout_ms || 30000,
        };
      } else {
        this.form = EMPTY();
      }
      this.show = true;
    },
    onHidden() {
      this.form = EMPTY();
    },
    async salvar() {
      if (!this.form.nome.trim()) {
        this.$bvToast.toast('Informe o nome da integração.', { variant: 'warning', solid: true, title: 'Atenção' });
        return;
      }
      if (!this.form.url.trim()) {
        this.$bvToast.toast('Informe a URL.', { variant: 'warning', solid: true, title: 'Atenção' });
        return;
      }
      const payload = {
        nome: this.form.nome.trim(),
        url: this.form.url.trim(),
        usuario: this.form.usuario || null,
        metodo: this.form.metodo,
        headers: this.form.headersStr && this.form.headersStr.trim()
          ? JSON.parse(this.form.headersStr)
          : null,
        body: this.form.body || null,
        status: this.form.status,
        timeout_ms: Number(this.form.timeout_ms) || 30000,
      };
      // Senha: só envia se informada (no edit em branco mantém atual)
      if (this.form.senha) payload.senha = this.form.senha;
      else if (!this.isEdit) payload.senha = null;

      try {
        if (this.isEdit) {
          await this.atualizar({ id: this.form.integracaoid, payload });
          this.$bvToast.toast('Integração atualizada.', { variant: 'success', solid: true, title: 'OK' });
        } else {
          await this.criar(payload);
          this.$bvToast.toast('Integração cadastrada.', { variant: 'success', solid: true, title: 'OK' });
        }
        this.show = false;
        this.$emit('saved');
      } catch (e) {
        // erros já são mostrados pelo errorShow do client
      }
    },
  },
};
</script>
